import React from "react";
import ConfirmEmail from "../ConfirmEmail";
import VerifyEmail from "../VerifyEmail";
import { Navigate, Route } from "react-router-dom";
import { EndPoints } from "../../../utils/apiEndpoints";

const { CONFIRMEMAIL, VERIFYEMAIL } = EndPoints;
export const VerifyEmailRoutes = () => (
    <React.Fragment>
        <Route path={CONFIRMEMAIL} element={<ConfirmEmail />} />
        <Route path={VERIFYEMAIL} element={<VerifyEmail />} />
        <Route path="*" element={<Navigate to={VERIFYEMAIL} replace />} />
    </React.Fragment>
);